__turbopack_context__.v({
  "switch": "bFlwya_switch",
  "thumb": "bFlwya_thumb",
});
